import React from "react";
import "./ServicesHighlight.css";
import { FaRocket, FaUsers, FaLightbulb } from "react-icons/fa";

const highlights = [
  {
    icon: <FaRocket className="highlight-icon" />,
    title: "Innovation et performance",
    desc: "Des solutions digitales à la pointe pour booster votre activité."
  },
  {
    icon: <FaUsers className="highlight-icon" />,
    title: "Accompagnement personnalisé",
    desc: "Un suivi sur-mesure, de l’analyse à la mise en production, pour garantir la réussite de vos projets."
  },
  {
    icon: <FaLightbulb className="highlight-icon" />,
    title: "Expertise et conseil",
    desc: "Notre équipe vous guide dans vos choix technologiques et stratégiques pour un impact durable."
  }
];

export default function ServicesHighlight() {
  return (
    <section className="services-highlight">
      <h2 className="highlight-title">L'expérience NEXUS SOLUTIONS</h2>
      <div className="highlight-list">
        {highlights.map((item, idx) => (
          <div className="highlight-card" key={idx}>
            {item.icon}
            <h3 className="highlight-card-title">{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
